import React, { useState, createContext } from "react";
import ContactData from "./ContactData";

export const ContactContext = createContext();

export const ContactContextProvider = (props) => {
    const [data, setData] = useState(ContactData);

    return <ContactContext.Provider value={{contextData: [data, setData]}}>{props.children}</ContactContext.Provider>
}